/**
 * 小于bad值就是差
 * 大于medium值就是优秀
 */
export const sentiment_frontier = {
  bad: 2.5,
  medium: 3.5,
};
